import React from "react";

function StreamingAnswer({ text, isDone }) {
  if (!text) return null;

  return (
    <div className="font-body text-[17px] leading-relaxed text-dupontBlue dark:text-darkText whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
      {text}
      {!isDone && (
        <span className="inline-block w-[2px] h-[16px] bg-dupontGold dark:bg-darkGold ml-[2px] align-middle animate-blink" />
      )}
    </div>
  );
}

export default StreamingAnswer;
